export default "__VITE_ASSET__VDBKS89c__"